export default (object: object) =>
  Object.entries(object).reduce((formData, [key, value]) => {
    formData.append(key, value);
    return formData;
  }, new URLSearchParams());
